import { ADD_TO_SELECTION, REMOVE_FROM_SELECTION, RESET_VIEW, SET_AVAILABLE_FIELDS, SET_NEW_ORDER, RESET_SELECTED_FIELDS, SET_ISDEFAULT_FIELD } from './actionTypes';

const initialState = {
  availableFields: [],
  selectedFields: [],
  allFields: [],
  isDefaultField: false,
};

const fields = (state = initialState, action) => {
  switch (action.type) {
    case SET_AVAILABLE_FIELDS:
      const { data, NeedRestriction } = action.payload;
      const dataCopy = _.cloneDeep(data);
      const parseData = NeedRestriction ? dataCopy.filter(value => !value.is_restricted_to_me) : dataCopy;

      return {
        ...state,
        allFields: parseData, // this was used by criteria section, without affecting original order.
        availableFields: parseData,
      };


    case ADD_TO_SELECTION:
      const { addedFields } = action.payload;
      const addedFieldIds = addedFields.map(field => field.id);
      const restAvailables = state.availableFields.filter(field => addedFieldIds.indexOf(field.id) === -1);
      // console.dir(addedFields);
      return {
        ...state,
        availableFields: restAvailables,
        // this makes the field only used once and advoid bug
        selectedFields: _.uniqBy([...state.selectedFields, ...addedFields], 'id'),
      };


    case REMOVE_FROM_SELECTION:
      const { removedFields, NeedRestri } = action.payload;
      const removedFieldIds = removedFields.map(field => field.id);
      const restSelection = state.selectedFields.filter(field => removedFieldIds.indexOf(field.id) === -1);
      const removedAndRestrictionFields = NeedRestri ? removedFields.filter(field => !field.is_restricted_to_me) : removedFields;
      // console.dir(removedFields);
      return {
        ...state,
        // this makes the field only used once and advoid bug
        availableFields: _.uniqBy([...state.availableFields, ...removedAndRestrictionFields], 'id'),
        selectedFields: restSelection,
      };


    case SET_NEW_ORDER:
      const { sortedArray } = action.payload;
      return {
        ...state,
        selectedFields: sortedArray,
      };

    case SET_ISDEFAULT_FIELD:
      const { isDefaultField } = action.payload;
      return {
        ...state,
        isDefaultField,
      };

    case RESET_SELECTED_FIELDS:
      return {
        ...state,
        selectedFields: initialState.selectedFields,
      };

    case RESET_VIEW:
      return initialState;


    default:
      return state;
  }
};

export default fields;



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/components/FieldsSelection/flow/reducer.js